import React from 'react';

export default (
  <path
    d="M16.3,1.7c0-0.3-0.1-0.7-0.4-0.9c-0.2-0.2-0.6-0.4-0.9-0.4H4.3C3.6,0.4,3,0.7,2.5,1.1C2,1.6,1.7,2.3,1.7,2.9
	v12.9c0,0.7,0.3,1.3,0.7,1.8c0.5,0.5,1.1,0.7,1.8,0.7h11.4c0.3,0,0.5-0.2,0.6-0.4c0.1-0.2,0-0.5-0.2-0.7c-0.2-0.2-0.3-0.4-0.4-0.6
	c-0.1-0.2-0.2-0.5-0.2-0.8c0-0.3,0-0.5,0.1-0.8c0.1-0.2,0.2-0.5,0.4-0.6l0,0l0,0l0,0l0,0l0.1-0.1c0,0,0,0,0,0
	c0.1-0.1,0.1-0.2,0.1-0.3c0,0,0,0,0-0.1c0,0,0,0,0-0.1V1.7z M15,13.4l-9.1,0V1.7H15V13.4z M3.4,2c0.2-0.2,0.6-0.4,0.9-0.4h0.4v11.7
	l-0.4,0h0c-0.4,0-0.9,0.1-1.3,0.4V2.9C3,2.6,3.1,2.3,3.4,2z M4.3,17.1c-0.3,0-0.7-0.1-0.9-0.4C3.1,16.5,3,16.2,3,15.9
	c0-0.3,0.1-0.7,0.4-0.9c0.2-0.2,0.6-0.4,0.9-0.4h0l10.2,0c0,0,0,0.1,0,0.1c0,0,0,0,0,0c-0.1,0.2-0.1,0.4-0.2,0.7H7.6
	c-0.3,0-0.5,0.2-0.5,0.5s0.2,0.5,0.5,0.5h6.7c0,0.3,0.1,0.5,0.2,0.8H4.3z M7.2,9.4h1l2.1,2.1c0.1,0.1,0.3,0.2,0.5,0.1
	c0.2-0.1,0.3-0.2,0.3-0.4V4.2c0-0.2-0.1-0.4-0.3-0.4c-0.2-0.1-0.4,0-0.5,0.1L8.2,6h-1C7,6,6.8,6.2,6.8,6.5v2.4
	C6.8,9.1,7,9.4,7.2,9.4z M7.7,6.9h0.7c0.1,0,0.2,0,0.3-0.1l1.5-1.5V10L8.8,8.6C8.7,8.5,8.6,8.4,8.4,8.4H7.7V6.9z M11.7,8.5
	C11.9,8.3,12,8,12,7.7s-0.1-0.6-0.3-0.8c-0.2-0.2-0.2-0.5,0-0.7c0.2-0.2,0.5-0.2,0.7,0c0.4,0.4,0.6,0.9,0.6,1.5s-0.2,1.1-0.6,1.5
	c-0.2,0.2-0.5,0.2-0.7,0C11.5,9,11.5,8.7,11.7,8.5z M12.5,6c-0.2-0.2-0.2-0.5,0-0.7c0.2-0.2,0.5-0.2,0.7,0c0.6,0.6,1,1.5,1,2.4
	s-0.4,1.7-1,2.4c-0.2,0.2-0.5,0.2-0.7,0s-0.2-0.5,0-0.7c0.4-0.4,0.7-1.1,0.7-1.7S13,6.4,12.5,6z"
  />
);
